import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(() => ({
  buttons: {
    background: '#1C846F',
    '&:hover': {
      background: '#0CABA8'
    },
    borderRadius: '5rem',
    color: '#fff'
  },
  root: {
    width: '100%',
    height: '100vh',
    overflow: 'auto',
    fontFamily: 'Roboto',
    '@media all and (max-width: 900px)': {
      alignItems: 'center',
      justifyContent: 'center',
      display: 'flex',
      flexDirection: 'column',
      height: '100vh'
      // marginTop: 80
    }
  }
}))

export default useStyles
